require('./helpers/bundle-manifest').register(JSON.parse("{\"5ZPII\":\"index.6ff9149b.js\",\"1fMV3\":\"feather-sprite.2b6a67b5.svg\"}"));